import React from "react";
import {Button, Card, CardBody, FormGroup, Input, Label} from "reactstrap";
import {inject, observer} from "mobx-react";
import Swal from "sweetalert2";

/**
 * Onglet « SMS » d'une prise en charge : on choisit un modèle, le client, son numéro et le produit
 * (les appareils de la prise en charge) sont déjà remplis, on voit le texte exact que recevra
 * le client avant d'envoyer.
 */
const SmsSender = (inject("rootStore")(observer(class SmsSender extends React.Component {

    timer = null;

    get injected() {
        return this.props;
    }

    get store() {
        return this.injected.rootStore.smsStore;
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            modeleId: "",
            contenu: "",
            produit: "",
            numero: this.injected.user?.profile?.telephone_portable ?? "",
            apercu: null,
            envoye: null,
        };
    }

    componentDidMount() {
        this.store.getTemplates();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    choisirModele(id) {
        const modele = this.store.modeles.find(m => String(m.id) === String(id));
        this.setState({modeleId: id, contenu: modele ? modele.contenu : "", envoye: null}, () => this.apercu());
    }

    changer(champ, valeur) {
        this.setState({[champ]: valeur, envoye: null}, () => this.apercu());
    }

    donnees() {
        return {
            contenu: this.state.contenu,
            pec_id: this.injected.pecId,
            numero: this.state.numero,
            valeurs: {produit: this.state.produit},
        };
    }

    apercu() {
        clearTimeout(this.timer);
        if (!this.state.contenu) {
            this.setState({apercu: null});
            return;
        }
        this.timer = setTimeout(async () => this.setState({apercu: await this.store.preview(this.donnees())}), 300);
    }

    async envoyer() {
        const {apercu} = this.state;
        const result = await Swal.fire({
            title: "Envoyer ce SMS ?",
            text: apercu.texte,
            footer: "Vers " + apercu.numero,
            icon: "question",
            confirmButtonText: "Envoyer",
            cancelButtonText: "Annuler",
            showCancelButton: true,
        });

        if (result.isConfirmed) {
            const sms = await this.store.send(this.donnees());
            if (sms) {
                this.setState({envoye: sms});
            }
        }
    }

    render() {
        const {apercu} = this.state;
        const pret = apercu && apercu.manquantes.length === 0 && apercu.numero;
        const user = this.injected.user;

        return (
            <Card className="mb-3">
                <CardBody>
                    <p>Client : <strong>{user?.fullname}</strong></p>
                    <FormGroup>
                        <Label>Modèle</Label>
                        <Input type="select" value={this.state.modeleId} onChange={e => this.choisirModele(e.target.value)}>
                            <option value="">— Choisir un modèle —</option>
                            {this.store.modeles.map(m => <option key={m.id} value={m.id}>{m.nom}</option>)}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label>Numéro de téléphone</Label>
                        <Input type="text" value={this.state.numero} placeholder="06 12 34 56 78"
                               onChange={e => this.changer("numero", e.target.value)}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Produit à récupérer</Label>
                        <Input type="text" value={this.state.produit} placeholder="Laisser vide : repris des appareils de la prise en charge"
                               onChange={e => this.changer("produit", e.target.value)}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Texte (modifiable pour ce client seulement)</Label>
                        <Input type="textarea" rows="4" maxLength="1000" value={this.state.contenu}
                               onChange={e => this.changer("contenu", e.target.value)}/>
                    </FormGroup>

                    <Label>Ce que recevra le client</Label>
                    <div style={{whiteSpace: "pre-wrap", background: "#e8f5e9", borderRadius: "12px", padding: "12px 14px", minHeight: "60px"}}>
                        {apercu ? apercu.texte : <span className="text-muted">Choisissez un modèle pour voir l'aperçu.</span>}
                    </div>
                    {apercu && <p className="mt-2 mb-1"><small className="text-muted">
                        {apercu.longueur} caractères — {apercu.nb_sms} SMS{apercu.numero ? " — vers " + apercu.numero : ""}
                    </small></p>}
                    {apercu && apercu.manquantes.length > 0 && <p className="text-danger mb-1"><small>
                        Valeur manquante : {apercu.manquantes.map(m => "{" + m + "}").join(", ")}. Remplissez le champ correspondant.
                    </small></p>}
                    {apercu && !apercu.numero && <p className="text-danger mb-1"><small>Numéro de téléphone absent ou invalide.</small></p>}
                    {this.state.envoye && <p className="text-success mb-1"><small>SMS mis en file vers {this.state.envoye.numero}.</small></p>}

                    <Button color="primary" className="mt-2" disabled={!pret} onClick={() => this.envoyer()}>Envoyer le SMS</Button>
                </CardBody>
            </Card>
        );
    }
})));

export default SmsSender;
